// extracted by mini-css-extract-plugin
module.exports = {"column":"column--2NHMxA3567","scrolling":"scrolling--1OOa2USd3s","loader":"loader--3rRdLe-ucL"};